module.exports = __webpack_public_path__ + "img/fig04.3085834c.jpg";